
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.845 2.565H1.155C.517 2.565 0 3.081 0 3.717v2.104h16V3.717c0-.636-.517-1.152-1.155-1.152zM2.003 4.69A.5.5 0 112 3.688a.5.5 0 01.002 1.002zm2.038 0a.5.5 0 110-1.002.5.5 0 010 1.002zm2.132 0a.5.5 0 11-.002-1.002.5.5 0 01.002 1.002zM0 6.814v8.034C0 15.484.517 16 1.155 16h13.69c.638 0 1.155-.516 1.155-1.152V6.814H0zm5.273 3.71l-.652 1.891a.498.498 0 01-.462.336H4.15a.498.498 0 01-.465-.32l-.236-.614-.206.598a.498.498 0 01-.462.336h-.009a.498.498 0 01-.465-.32l-.726-1.891a.498.498 0 01.93-.355l.236.614.206-.598c.102-.36.723-.514.936-.017l.236.615.206-.598a.499.499 0 01.942.322zm4.576 0l-.652 1.891a.498.498 0 01-.462.336h-.01a.498.498 0 01-.464-.32l-.236-.614-.206.598a.498.498 0 01-.462.336h-.01a.498.498 0 01-.464-.32l-.726-1.891a.498.498 0 01.93-.355l.236.614.206-.598c.114-.385.751-.478.936-.017l.236.615.206-.598a.499.499 0 01.942.322zm4.576 0l-.652 1.891a.498.498 0 01-.463.336h-.008a.498.498 0 01-.466-.32l-.235-.614-.206.598a.498.498 0 01-.463.336h-.008a.498.498 0 01-.465-.32l-.726-1.891a.498.498 0 01.93-.355l.236.614.206-.598c.113-.37.728-.508.936-.017l.236.615.206-.598a.499.499 0 01.942.322z","fill":"#6C6C6C"}})])
          )
        }
      }
    